import React from 'react'
// Import necessary components.
import { withStyles } from '@mui/styles'
import Switch from '@mui/material/Switch'

// Build the component.
const FieldSwitch = withStyles(theme => ({
  // Set the root style.
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1)
  },
  // Set switch base.
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: theme.palette.primary.main,
        opacity: 1,
        border: 'none'
      }
    },
    '&$focusVisible $thumb': {
      color: theme.palette.common.white
    }
  },
  // Set the thumb dimension.
  thumb: {
    width: 24,
    height: 24
  },
  // Set the track style.
  track: {
    borderRadius: 26 / 2,
    backgroundColor: '#E2E2E2',
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border'])
  },
  checked: {},
  focusVisible: {}
}))(({ classes, ...props }) => {
  // Return the component with all custom style.
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked
      }}
      {...props}
    />
  )
})

// Return the component for use.
export default FieldSwitch
